/**
 * Takes an Umbraco Properties array and create js object
 * @param {Array} properties - The string to convert.
 */
export const propertiesToObject = item => {
	let object = {};

	// Default object
	let properties = item.Properties;
	object._id = item.Id;
	object._updatedDate = item.UpdatedDate;
	object._url = item.Url;
	object._contentType = item.ContentType;
	object._createdDate = item.CreatedDate;
	object._author = item.Author;

	// Add properties to the obj
	for (let prop in properties) {
		if (Object.prototype.hasOwnProperty.call(properties, prop)) {
			let propItem = properties[prop];
			object[propItem.PropertyTypeAlias] = propItem.Content;
		}
	}
	return object;
};

export default {
	propertiesToObject
};
